<app-dynamic-form title="Bank" [input]="data!" (result)="doHandleResult($event)"></app-dynamic-form>
